import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Driver } from "../state/types"

export const useDriverActions = () => {
    const saveActions = useSaveActions()

    const saveDriver = (driver: Driver) => {
        const { save } = saveActions()
        return save(TableName.DRIVERS, driver) as Promise<Driver>
    }

    const removeDriver = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.DRIVERS, id)
    }

    return {
        saveDriver,
        removeDriver
    }
}
